import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';
import bildUberspringen from '@/assets/icons/arrow.svg';

export const wishWallboxAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '19713', image: bildJa },
    { name: 'Nein', available: true, value: 'nein', api: '19714',  image: bildNein },
    { name: 'Überspringen', available: true, value: 'unknown', api: null,  image: bildUberspringen },
];

export const wishWallboxApi = {parameter: '17021', type: 'value_choice'};